export default "__VITE_ASSET__BxmK9dgZ__"